"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var Document_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Document = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const uuid_1 = require("uuid");
const statusGetter_1 = require("../statusGetter");
const transformToDate_1 = require("../transformers/transformToDate");
let Document = Document_1 = class Document {
    _id = (0, uuid_1.v4)();
    createdAt = new Date();
    documentTypeId;
    fileIds = [];
    description;
    acceptedAt;
    declinedAt;
    outdatedAt;
    deletedAt;
    issueAt;
    expiryAt;
    declinationReason;
    managementNote;
    externalDocumentId;
    kycStatus;
    extractedData;
    autoAcceptedAt;
    autoDeclinedAt;
    firstExpirationReminderSentAt;
    secondExpirationReminderSentAt;
    getStatus() {
        if (this.kycStatus) {
            return this.kycStatus;
        }
        const virtualStatus = (0, statusGetter_1.statusGetter)(this, Document_1, legacy_enums_1.DocumentStatus);
        return virtualStatus;
    }
    static statusPrototype(status) {
        const defined = new Date();
        switch (status) {
            case legacy_enums_1.DocumentStatus.OUT_OF_DATE:
                return {
                    outdatedAt: defined,
                };
            case legacy_enums_1.DocumentStatus.REFUSED:
                return {
                    declinedAt: defined,
                };
            case legacy_enums_1.DocumentStatus.VALIDATED:
                return {
                    acceptedAt: defined,
                    declinedAt: undefined,
                };
            case legacy_enums_1.DocumentStatus.VALIDATION_ASKED:
            default:
                return {
                    declinedAt: undefined,
                    acceptedAt: undefined,
                };
        }
    }
};
exports.Document = Document;
__decorate([
    (0, class_validator_1.IsUUID)("4"),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Document.prototype, "_id", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Expose)(),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Date)
], Document.prototype, "createdAt", void 0);
__decorate([
    (0, class_validator_1.IsUUID)("4"),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Document.prototype, "documentTypeId", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Array)
], Document.prototype, "fileIds", void 0);
__decorate([
    (0, class_validator_1.MaxLength)(512),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Document.prototype, "description", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Expose)(),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Date)
], Document.prototype, "acceptedAt", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Expose)(),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Date)
], Document.prototype, "declinedAt", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Expose)(),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Date)
], Document.prototype, "outdatedAt", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Expose)(),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Date)
], Document.prototype, "deletedAt", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Expose)(),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Date)
], Document.prototype, "issueAt", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Expose)(),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Date)
], Document.prototype, "expiryAt", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Document.prototype, "declinationReason", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Document.prototype, "managementNote", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Document.prototype, "externalDocumentId", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Document.prototype, "kycStatus", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], Document.prototype, "extractedData", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Expose)(),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Date)
], Document.prototype, "autoAcceptedAt", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Expose)(),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Date)
], Document.prototype, "autoDeclinedAt", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Expose)(),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Date)
], Document.prototype, "firstExpirationReminderSentAt", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Expose)(),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Date)
], Document.prototype, "secondExpirationReminderSentAt", void 0);
exports.Document = Document = Document_1 = __decorate([
    (0, class_transformer_1.Exclude)()
], Document);
//# sourceMappingURL=Document.js.map